import Cookies from 'js-cookie';

const handler = ( $ ) => {

	const $formRadios = $('#members-directory-filters .hidden-radio'),
	$searchInput = $('#members-directory-search-input'),
	$expertiseDropdown = $('#members-directory-expertise-dropdown'),
	$suggestions = $('#members-directory-suggestions'),
	$searchClear = $('#members-directory-search-input-clear');

	let isExpertiseDropdownOpen = false;

	const toNumber = function( value ) {
		return parseFloat( value ) || 0;
	};

	const updateExpertiseDropdownHeight = function( selectric ) {
		const $items = selectric.elements.items,
			viewportOffset = 24,
			minHeight = 80,
			maxHeight = 620,
			itemsOffset = toNumber( $items.css( 'paddingTop' ) )
				+ toNumber( $items.css( 'paddingBottom' ) )
				+ toNumber( $items.css( 'borderTopWidth' ) )
				+ toNumber( $items.css( 'borderBottomWidth' ) ),
			wrapperBottom = selectric.elements.outerWrapper[0].getBoundingClientRect().bottom,
			availableHeight = window.innerHeight - wrapperBottom - viewportOffset - itemsOffset;

		$items.css( 'height', '' );
		selectric.options.maxHeight = Math.max( minHeight, Math.min( maxHeight, availableHeight ) );
	};

	const closeExpertiseDropdown = function() {
		if( isExpertiseDropdownOpen ) {
			$expertiseDropdown.selectric( 'close' );
		}
	};

	$expertiseDropdown.selectric( {
		maxHeight: 620,
		disableOnMobile: false,
		nativeOnMobile: false,
		forceRenderBelow: true,
		onBeforeOpen: function( element, selectric ) {
			updateExpertiseDropdownHeight( selectric );
		},
	} );

	$expertiseDropdown.on( 'selectric-open', function() {
		isExpertiseDropdownOpen = true;
	} );

	$expertiseDropdown.on( 'selectric-close', function() {
		isExpertiseDropdownOpen = false;
	} );

	$( window ).add( '#content' ).on( 'scroll.membersDirectoryFilters', closeExpertiseDropdown );

	// suggestions
	let timeout = null;
	$searchInput.on( 'keyup paste', function( e ) {

		if(e.key === 'Enter' || e.keyCode === 13) {
			handleFiltersForm();
			return false;
		}

		let search_type = $formRadios.find('input[type=radio]:checked').val();

		if( $.trim( $searchInput.val() ) == '' ) {
			$searchClear.hide();
		} else {
			$searchClear.show();
		}

		clearTimeout(timeout);
		timeout = setTimeout(function () {

			if( $searchInput.val().length >= 3 ) {

				$.ajax( {
					url: themeVars.ajaxurl,
					type: 'POST',
					dataType: 'json',
					data: {
						action: 'fp_suggest_members_directory',
						search: $searchInput.val(),
						search_type: search_type,
						nonce: Cookies.get( 'wordpress_pen_ajax_nonce' ),
					},
					success: function ( answer ) {
	
						$suggestions.html( answer.items ).fadeIn('fast');
	
					},
				} );

			}

			handleFiltersForm();

		}, 500 );
	});

	// suggest item into search field
	$(document).on('click', '#members-directory-suggestions .item', function( e ) {
		e.preventDefault();
		const $el = $(this);

		let search_type = $formRadios.find('input[type=radio]:checked').val();

		if( search_type == 'name' ) {
			window.location = $el.data('url');
		} else {
			$searchInput.val( $(this).html() );
			handleFiltersForm();
		}
		
		$suggestions.hide();
		$searchClear.show();
		
	});

	// hide suggestions by clicking outside
	$(document).on( 'click', function( e ) {

		if( $( e.target).closest( '#members-directory-suggestions').length === 0) {
			$suggestions.hide();
		}

	});

	// clear search
	$searchClear.on( 'click', function( e ) {
		e.preventDefault();
		$(this).hide();
		$expertiseDropdown.val('').selectric('refresh');
		$searchInput.val('');
		handleFiltersForm();
	});

	// handle filters form
	const handleFiltersForm = function() {

		let stateURL = {};

		const searchType = $formRadios.find('input[type=radio]:checked').val(),
		expertise = $expertiseDropdown.val(),
		search = $.trim( $searchInput.val() );

		if( search != '' ) {

			if( searchType == 'name' ) {
				stateURL = Object.assign({
					'search' : search
				}, stateURL );
			} else {
				stateURL = Object.assign({
					'jurisdiction' : search
				}, stateURL );
			}

		}

		if( expertise != '' ) {
			stateURL = Object.assign({
				'expertise' : expertise
			}, stateURL);
		}

		const base = ( location.protocol + '//' + location.host + location.pathname ),
		params = new URLSearchParams(stateURL).toString();
		if( params != '' ) {
			history.pushState( '', '', base + '?' + params ); 
		} else {
			history.pushState( '', '', base ); 
		}

		const $postsHolder = $('#posts'),
		$loadMoreHolder = $('#ajax-pagination-load-more'),
		$loadedPosts = $('#members-directory-filters .loaded-posts-num'),
		$allPostsNum = $('#members-directory-filters .all-posts-num');

		$.ajax( {
			url: themeVars.ajaxurl,
			type: 'POST',
			dataType: 'json',
			data: {
				action: 'fp_filter_members_directory',
				filters: stateURL,
				nonce: Cookies.get( 'wordpress_pen_ajax_nonce' ),
			},
			beforeSend: function () {
				$postsHolder.addClass( 'is-loading' );
			},
			success: function ( answer ) {
				$postsHolder.removeClass( 'is-loading' ).html( answer.posts );

				if( answer.noResults ) {
					$postsHolder.addClass('no-results');
				} else {
					$postsHolder.removeClass('no-results');
				}

				$loadMoreHolder.html( answer.loadMoreLink );
				$loadedPosts.html( $postsHolder.find('article').length );
				$allPostsNum.html( answer.allResultsNum );
			},
		} );

	}

	// change search type
	$formRadios.find('input[type=radio]').on( 'change', function() {

		const $el = $(this),
		$parent = $el.parent();

		$searchInput.val('');

		if( $(this).is(':checked') ) {
			$formRadios.not( $parent ).removeClass('is-active');
			$parent.addClass('is-active');
			$searchClear.hide();
			$expertiseDropdown.val('').selectric('refresh');
			handleFiltersForm();
		}

	});

	// dropdown on change
	$expertiseDropdown.on( 'change', function() {
		handleFiltersForm();
	});

};

export default ( ( $ ) => $( handler ) )( jQuery );
